let settings = {
    development: {
        betradarApiUrl: 'https://btrd-tbet.oddin-platform.com/api/',
        sportsApiUrl: 'https://tbet.oddin-platform.com/sportsofferapi/api/',
        boApiUrl: 'https://tbet.oddin-platform.com/backofficeapi/api/',
        lottoApiUrl: 'https://tbet.oddin-platform.com/lottoapi/api',
        printTemplates: 'https://tbet.oddin-platform.com/print',
        lsportsClientApiUrl: 'https://tbet.oddin-platform.com/lsportsclientapi/api',
        lsportsProviderApiUrl: '',
        terminalApi: 'https://tbet.oddin-platform.com/terminalapi/api',
    },
    production: {
        betradarApiUrl: 'https://btrd-tbet.oddin-platform.com/api/',
        sportsApiUrl: 'https://tbet.oddin-platform.com/sportsofferapi/api/',
        boApiUrl: 'https://tbet.oddin-platform.com/backofficeapi/api/',
        lottoApiUrl: 'https://tbet.oddin-platform.com/lottoapi/api',
        printTemplates: 'https://tbet.oddin-platform.com/print',
        lsportsClientApiUrl: 'https://tbet.oddin-platform.com/lsportsclientapi/api',
        lsportsProviderApiUrl: '',
        terminalApi: 'https://tbet.oddin-platform.com/terminalapi/api',
    },
};

export default settings;
